import { MousePointer } from "lucide-react";
import React from "react";

import { IgAvatar } from "@intelligems/ig-theme/IgAvatar";
import { IgDivider } from "@intelligems/ig-theme/IgDivider";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { CopyFromOtherGroupsAccordion } from "@src/features/experienceBuilder/modifications/copyMod/CopyFromOtherGroupsAccordion";
import { useSelector } from "@src/store";
import { ExperienceBuilderSelector as Selector } from "@src/store/slices/experienceBuilder";

export const ModificationsNavigateEmptyState = () => {
  const theme = useTheme();
  const shouldShowOtherMods = useSelector(Selector.shouldShowOtherMods);

  return (
    <>
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2.5}
        sx={{
          px: 2.5,
          py: 8,
          textAlign: "center",
          ...(shouldShowOtherMods ? { height: 363 } : { flex: 1 }),
        }}
      >
        <IgAvatar
          variant="circular"
          sx={{
            backgroundColor: theme.igPrimitives.gray[900],
            width: 50,
            height: 50,
          }}
        >
          <MousePointer size={24} color={theme.palette.text.secondary} />
        </IgAvatar>
        <Stack spacing={1} alignItems="center" maxWidth={292}>
          <IgTypography fontWeight={600}>Navigate your site</IgTypography>
          <IgTypography variant="body2" color={theme.palette.text.secondary}>
            Use navigation to get to the page you want, then switch back to
            Select to choose an element.
          </IgTypography>
        </Stack>
      </Stack>
      {shouldShowOtherMods && (
        <>
          <IgDivider />
          <Stack sx={{ px: 4 }}>
            <CopyFromOtherGroupsAccordion />
          </Stack>
        </>
      )}
    </>
  );
};
